import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const APPLICATIONS_PER_PAGE = 10;

export const useGetMyApplications = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getAllApplications = (page: number = 1, limit: number = APPLICATIONS_PER_PAGE) => {
    send({}, `/api/v1/application/forJobSeeker?limit=${limit}&page=${page}`).then();
  };

  const getAppliedApplications = (page: number = 1, limit: number = APPLICATIONS_PER_PAGE) => {
    send(
      {},
      `/api/v1/application/forJobSeeker?limit=${limit}&page=${page}&applicationType=APPLY`
    ).then();
  };

  const getInvitedApplications = (page: number = 1, limit: number = APPLICATIONS_PER_PAGE) => {
    send(
      {},
      `/api/v1/application/forJobSeeker?limit=${limit}&page=${page}&applicationType=INVITE`
    ).then();
  };

  return {
    getAllApplications,
    getAppliedApplications,
    getInvitedApplications,
    data,
    isLoading,
    error,
  };
};
